
<template lang="pug">
.grid__tr
  .grid__column-header(
    v-for="col of cols"
    :style="[style, col.style]"
  ) {{getText_(col)}}
</template>

<script>
export default {
  props: {
    grid: {type: Object, required: true},
    cols: {type: Array, required: true},
    getText: Function,
  },

  computed: {
    style() {
      return {
        width: this.grid.cellW + 'px',
        height: this.grid.headerH + 'px',
      }
    },

    getText_() {
      return this.getText || (col => col.text)
    },
  },
}
</script>
